import React from "react";
import search from "../assets/images/restaurants/search.png";
import food from "../assets/images/order/food.png";
import GroupOrderedItem from "../components/GroupOrderedItem";
import qrcode from "../assets/images/group/qr.png";
import link from "../assets/images/group/link.png";
import edit from "../assets/images/group/edit2.png";
import clock from "../assets/images/group/clock.png";
import creditcard from "../assets/images/support/credit-card.png";
import location from "../assets/images/location.png";
import rightarrow from "../assets/images/arrow-right.png";

const GroupOrder = () => {
 const items = [
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rohan",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Ronit",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Aman",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Yash",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rittik",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Rokey",
    },
    {
      image: food,
      itemName: "Garlic Noodles",
      itemPrice: 100,
      discountedPrice: 80,
      quantity: "5 Qty",
      addedBy: "Krish",
    },
  ];

  return (
    <div className="flex border-2 bg-[#FFFFFF]">
      <div className="w-[35%] border-r py-6">
        <div className="px-8">
          <h6 className="text-[#6A6A6A] text-left font-Urbanist text-[16px] font-medium leading-[20px] ml-[23px]">
            Search / Asian Kitchen / Group Order
          </h6>

          {/* QR Code Details */}
          <div className="mt-4 min-w-[418px] w-full flex flex-col justify-center items-center gap-[25px]">
            <div>
              <div className="flex justify-center items-center ">
                <img
                  src={qrcode}
                  alt="QR Code"
                  className="h-[193px] w-[193px] object-cover rounded-[16px]"
                />
              </div>

              <div className="flex justify-center items-center my-[12px] gap-[8px] cursor-pointer px-[12px] py-[10px] bg-[#F5F5F5] rounded-[8px] w-fit mx-auto">
                <img src={link} alt="Link" className="h-[24px] w-[24px]" />
                <span className="text-[#6A6A6A] text-[16px] font-medium">
                  Copy Link
                </span>
              </div>

              <div className="flex flex-col justify-center items-center">
                <div className="flex gap-4 items-center mt-[4px]">
                  <h6 className="text-[#050505] font-Urbanist text-[22px] font-semibold leading-[140%] ">
                    Aman Bansal’s Group
                  </h6>
                  <img src={edit} alt="Edit" className="w-[20px] h-[20px]" />
                </div>
                <p className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[140%] ">
                  Made by You - 45 Members (Valid for{" "}
                  <span className="text-[#7604A5]">16:32</span>)
                </p>
              </div>
            </div>

            {/* address */}
            <div className="border-[#E3E3E3] rounded-[16px] border-2 p-[12px] w-[80%] mx-auto">
              <h6 className="text-[#050505] font-Urbanist text-[16px] font-semibold leading-[140%] border-b-2 pb-[12px]">
                Address
              </h6>
              <h6 className="text-[#050505] font-Urbanist text-[14px] font-medium leading-[160%] pt-[12px]">
                F 43, Block C, Sector 62, Noida, Uttar Pradesh
              </h6>
            </div>

            <div className="h-[1px] w-[80%] bg-[#E3E3E3] mx-auto"></div>

            {/* delivery and payment details */}
            <div className="border rounded-[16px] p-[12px] w-[80%] mx-auto">
              <div className="flex gap-[12px] items-center pb-[12px]  border-b-2">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img src={clock} alt="clock" className="h-[24px] w-[24px]" />
                </div>
                <div>
                  <h6 className="text-[#6A6A6A] text-start font-Urbanist text-[14px] font-medium leading-[140%]">
                    When to Deliver
                  </h6>
                  <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                    Deliver Now
                  </p>{" "}
                </div>
              </div>
              <div className="flex gap-[12px] items-center py-[12px]  border-b-2">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img
                    src={location}
                    alt="location"
                    className="h-[24px] w-[24px]"
                  />
                </div>
                <div>
                  <h6 className="text-[#6A6A6A] text-start font-Urbanist text-[14px] font-medium leading-[140%]">
                    Where to Deliver
                  </h6>
                  <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                    Sector 62, Noida, Uttar Pradesh
                  </p>{" "}
                </div>
              </div>
              <div className="flex gap-[12px] items-center mt-[12px]">
                <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                  <img
                    src={creditcard}
                    alt="credit card"
                    className="h-[24px] w-[24px]"
                  />
                </div>
                <div>
                  <h6 className="text-[#6A6A6A] text-start font-Urbanist text-[14px] font-medium leading-[140%]">
                    Who is Paying
                  </h6>
                  <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                    You are paying for this order
                  </p>{" "}
                </div>
              </div>
            </div>

            <button
              className="w-[80%] mx-auto flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors"
              // onClick={() => {
              //   navigate("/group-order");
              // }}
            >
              <span className="w-full text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
                Create Your Group
                <img
                  src={rightarrow}
                  alt="Right Arrow"
                  className="inline-block ml-2 h-[24px] w-[24px]"
                />
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="w-[65%] border-l relative">
        {/* Tabs */}
        <div className=" mt-[15px]">
          <div className="flex justify-between items-center mx-[20px] px-[32px]">
            <span className="text-[#6A6A6A] text-start font-Urbanist text-[20px] font-medium leading-[120%]">
              Item
            </span>
            <span className="text-[#7604A5] text-start font-Urbanist text-[20px] font-medium leading-[120%]">
              {" "}
              + Add Items
            </span>
          </div>
        </div>

        {/* items section */}
        <div className="px-12">
          {items.map((item, index) => (
            <GroupOrderedItem
              key={index}
              image={item.image}
              itemName={item.itemName}
              itemPrice={item.itemPrice}
              discountedPrice={item.discountedPrice}
              quantity={item.quantity}
              addedBy={item.addedBy}
              //   onCountChange={(count) => handleItemCountChange(index, count)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GroupOrder;
